import { render, staticRenderFns } from "./GopNotification.vue?vue&type=template&id=481bb480&scoped=true"
import script from "./GopNotification.vue?vue&type=script&lang=js"
export * from "./GopNotification.vue?vue&type=script&lang=js"
import style0 from "./GopNotification.vue?vue&type=style&index=0&id=481bb480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481bb480",
  null
  
)

export default component.exports